/* globals ResponsiveUtil */

import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class Info {
	static classname = 'info';

	constructor($item) {
		this.$item = $item;

		this.init();
	}

	init() {
		if (ResponsiveUtil.isToTablet()) {
			this.$item.find('table').wrap("<div class='js-scrollbar' style='position:relative'></div>" );
		}
	}

}
